import Vue from "vue";

export default {
  recuperarMunicipios() {
    return Vue.axios.get("municipio");
  },
};
